import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuardService } from './services/auth-guard.service';
import { SiteComponent } from './components/site/site.component';
import { ProgramComponent } from './components/program/program.component';
import { ProgramHomeComponent } from './components/program/program-home/program-home.component';
import {ProgramViewComponent} from './components/program/program-view/program-view.component';
import {NotFoundComponent} from './components/shared/not-found/not-found.component';
import {CanDeactivateGuard} from './services/can-deactivate-guard.service';
import {SiteFinancialComponent} from "./components/site/site-financial/site-financial.component";
import {SiteDevicesComponent} from "./components/site/site-devices/site-devices.component";
import {SiteHomeComponent} from "./components/site/site-home/site-home.component";
import {ControlComponent} from "./components/control/control.component";
import { PermissionEnum } from './permission.enum';
import { SiteOperationsComponent } from './components/site/site-operations/site-operations.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'program/home',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuardService],
    data: { requiredPermissions: [PermissionEnum.read] },
  },
  {
    path: 'site/:id',
    component: SiteComponent,
    canActivate: [AuthGuardService],
    data: { requiredPermissions: [PermissionEnum.read] },
    canDeactivate: [CanDeactivateGuard],
    children: [
      {
        path: '',
        component: SiteComponent
      },
      {
        path: 'home',
        component: SiteHomeComponent,
        canActivate: [AuthGuardService],
        data: { requiredPermissions: [PermissionEnum.read] },
        canDeactivate: [CanDeactivateGuard],
      },
      {
        path: 'financial',
        component: SiteFinancialComponent,
        canActivate: [AuthGuardService],
        data: { requiredPermissions: [PermissionEnum.read] },
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'devices',
        component: SiteDevicesComponent,
        canActivate: [AuthGuardService],
        data: { requiredPermissions: [PermissionEnum.read] },
        canDeactivate: [CanDeactivateGuard]
      },
      {
        path: 'operations',
        component: SiteOperationsComponent,
        canActivate: [AuthGuardService],
        data: { requiredPermissions: [PermissionEnum.update] },
        canDeactivate: [CanDeactivateGuard]
      },
    ]
  },
  {
    path: 'program',
    component: ProgramComponent,
    canActivate: [AuthGuardService],
    data: { requiredPermissions: [PermissionEnum.read] },
    children: [
      {
        path: '',
        component: ProgramComponent,
        canActivate: [AuthGuardService],
        data: { requiredPermissions: [PermissionEnum.read] },
      },
      {
        path: 'home',
        component: ProgramHomeComponent,
        canActivate: [AuthGuardService],
        data: { requiredPermissions: [PermissionEnum.read] },
      },
      {
        path: ':id/view',
        component: ProgramViewComponent,
        canActivate: [AuthGuardService],
        canDeactivate: [CanDeactivateGuard],
        data: { requiredPermissions: [PermissionEnum.read] },
      }
    ]
  },
  {
    path: 'control/home',
    component: ControlComponent,
    canActivate: [AuthGuardService],
    data: { requiredPermissions: [PermissionEnum.read] },
    children: []
  },
  {
    path: '**',
    component: NotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
